import { apiPrefixes } from '@/api/apiPrefixes'
import {
  httpWithCookie,
  http,
  getYMDHMS,
  translateNums,
  toCLogin
} from '@/utils'
import { Toast } from 'vant'

const api = {
  checkLogin: `${apiPrefixes.recuritment}/ehr-web/api/mobile/recruitEmploy/checkLogin.do`, // 校验是否登陆
  queryCms: `${apiPrefixes.cms997}/recruitment.json`, // cms配置招聘信息
  getNcConf: `${apiPrefixes.recuritment}/ehr-web/api/mobile/sysConf/getNcConf.do`, // 城市信息
  getList: `${apiPrefixes.recuritment}/ehr-web/api/mobile/baseConfig/getList.do`, // 城市信息
  postTypeList: `${apiPrefixes.recuritment}/ehr-web/api/mobile/postManagement/postTypeList.do`, // 职位类别列表
  postList: `${apiPrefixes.recuritment}/ehr-web/api/mobile/postManagement/postList.do`, // 职位列表
  postDetail: `${apiPrefixes.recuritment}/ehr-web/api/mobile/postManagement/postDetail.do`, // 职位详情
  upload: `${apiPrefixes.recuritment}/ehr-web//api/mobile/upload.file`, // 简历解析
  getResumeByPhone: `${apiPrefixes.recuritment}/ehr-web/api/mobile/recruitManage/getResumeByPhone.do`, // 简历详情标准版
  getApplyList: `${apiPrefixes.recuritment}/ehr-web/api/mobile/recruitEmploy/getApplyListByPhone.do`, // 应聘记录
  queryInterviewDetail: `${apiPrefixes.recuritment}/ehr-web//api/mobile/recruitEmploy/queryInterviewDetail.do`, // 我的面试
  queryInterviewList: `${apiPrefixes.recuritment}/ehr-web/api/mobile/recruitEmploy/queryInterviewList.do`, // 我的面试列表
  updateInterviewCfmStatus: `${apiPrefixes.recuritment}/ehr-web/api/mobile/interviewManage/updateInterviewCfmStatus.do`, // 接受/拒绝面试
  getOfferList: `${apiPrefixes.recuritment}/ehr-web/api/mobile/recruitEmploy/getOfferListByPhone.do`, // 我的offer
  updateOfferCfmStatus: `${apiPrefixes.recuritment}/ehr-web/api/mobile/offerManage/updateOfferCfmStatus.do`, // 接受/拒绝offeer
  sendVerifyCode: `${apiPrefixes.recuritment}/ehr-web/api/mobile/login/sendVerifyCode.do`, // 发送验证码
  loginVCode: `${apiPrefixes.recuritment}/ehr-web/api/mobile/login/loginVCode.do`, // 登陆
  saveResumeApply: `${apiPrefixes.recuritment}/ehr-web/api/mobile/recruitManage/saveResumeApply.do`, // 保存简历
  parseResumeFromResumeData: `${apiPrefixes.recuritment}/ehr-web/api/mobile/recruitManage/parseResumeFromResumeData.do`, // 解析简历数据
  saveApply: `${apiPrefixes.recuritment}/ehr-web/api/mobile/recruitEmploy/saveApply.do`, // 投递简历
  finishPersonalInfo: `${apiPrefixes.recuritment}/ehr-web/api/mobile/preEmployment/queryCurrentProcess.do` // 是否填写完预入职信息
  //

  // /ehr-web?type=&id=&objectType=
}

const baseMobileUrl = `${apiPrefixes.recuritment}/ehr-web/api/mobile`

async function requstData(requestParams: any) {
  try {
    const res: any = await httpWithCookie(requestParams)
    if (+res.code === 1024) {
      toCLogin(location.href)
    } else if (+res.code === 1) {
      return res
    } else {
      Toast(res.msg)
      return Promise.reject(res.msg)
    }
  } catch (e) {
    return Promise.reject()
  }
}

/*
 * cms配置招聘信息
 */
export async function queryCmsInfo() {
  try {
    const res: any = await http.get(`${api.queryCms}`)
    if (res.code === 0) {
      return res.data || {}
    } else {
      throw res.msg
    }
  } catch (e) {
    return null
  }
}

/*
 * 获取城市信息
 */
export async function getNcConf(data: any) {
  try {
    const res: any = await httpWithCookie.get(`${api.getNcConf}?code=${data}`)
    if (+res.code === 1024) {
      toCLogin(location.href)
    } else if (+res.code === 1) {
      const data = res.data || []
      const cityList = data.map((item: any) => {
        item.code = item.dtlPk
        item.value = item.dtlName
        return item
      })
      return cityList || []
    } else {
      Toast(res.msg)
      throw res.msg
    }
  } catch (e) {
    return null
  }
}
/*
 * 获取职位类别
 */
export async function checkLogin() {
  try {
    const res: any = await httpWithCookie.get(`${api.checkLogin}`)
    if (+res.code === 1024) {
      toCLogin(location.href)
    } else if (+res.code === 1) {
      return res
    } else {
      throw res.msg
    }
  } catch (e) {
    return null
  }
}
//
/*
 * 获取职位类别（旧接口，保留兼容）
 */
export async function getZwConf() {
  try {
    const res: any = await httpWithCookie.get(`${api.getList}?code=zwlb&type=1`)
    if (+res.code === 1024) {
      toCLogin(location.href)
    } else if (+res.code === 1) {
      return res.data || []
    } else {
      Toast(res.msg)
      throw res.msg
    }
  } catch (e) {
    return null
  }
}
/*
 * 获取职位类别列表（新接口）
 */
export async function getPostTypeList() {
  try {
    const res: any = await httpWithCookie.get(`${api.postTypeList}`)
    if (+res.code === 1024) {
      toCLogin(location.href)
    } else if (+res.code === 1) {
      return res.data || []
    } else {
      Toast(res.msg)
      throw res.msg
    }
  } catch (e) {
    return null
  }
}
/*
 * 查询职位列表
 */
export async function getPostList(data: any) {
  try {
    const res: any = await httpWithCookie.post(`${api.postList}`, data)
    if (+res.code === 1024) {
      toCLogin(location.href)
    } else if (+res.code === 1) {
      const data = res.data.list || []
      const list = data.map((item: any) => {
        return {
          ...item,
          postId: item.id,
          salaryMin: translateNums(item.salaryMin, 1000, 1),
          salaryMax: translateNums(item.salaryMax, 1000, 1)
        }
      })
      const count = res.data?.pageCond?.count || 0
      return { list, count } || {}
    } else {
      Toast(res.msg)
      throw res.msg
    }
  } catch (e) {
    return null
  }
}
/*
 * 职位详情
 */
export async function getPostDetail(data: any) {
  try {
    const res: any = await httpWithCookie.get(
      `${api.postDetail}?postId=${data}`
    )
    if (+res.code === 1024) {
      toCLogin(location.href)
    } else if (+res.code === 1) {
      return res.data || {}
    } else {
      Toast(res.msg)
      throw res.msg
    }
  } catch (e) {
    return null
  }
}
/*
 * 简历详情标准
 */
export async function queryResumeByPhone() {
  try {
    const res: any = await httpWithCookie.get(`${api.getResumeByPhone}?type=2`)
    if (+res.code === 1024) {
      toCLogin(location.href)
    } else if (+res.code === 1 || +res.code === 870009) {
      console.log(res)
      return res || {}
    } else {
      Toast(res.msg)
      throw res.msg
    }
  } catch (e) {
    return null
  }
}

/*
 * 应聘记录
 */
export async function getApplyList() {
  try {
    const res: any = await httpWithCookie.get(`${api.getApplyList}`)
    if (+res.code === 1024) {
      toCLogin(location.href)
    } else if (+res.code === 1) {
      const data = res.data.map((item: any) => {
        console.log(item, 'item1111')
        return {
          ...item,
          desctype: 'record',
          postName: item?.postEntity?.postName || '',
          salaryMin: translateNums(item?.postEntity?.salaryMin, 1000, 1) || '',
          salaryMax: translateNums(item?.postEntity?.salaryMax, 1000, 1) || '',
          applyTime: getYMDHMS(item.applyTime, 'date'),
          salaryType: item?.postEntity?.salaryType || 0,
          deptName: item?.postEntity?.deptName || '',
          placeName: item?.postEntity?.placeName || '',
          zwlb: item?.postEntity?.zwlb || '',
          quName: item?.postEntity?.quName || '',
          zplb: item?.postEntity?.zplb || ''
        }
      })
      return data || []
    } else {
      Toast(res.msg)
      throw res.msg
    }
  } catch (e) {
    return null
  }
}
/*
 * 面试信息详情
 */
export async function queryInterviewDetail(data: any) {
  try {
    const res: any = await httpWithCookie.get(
      `${api.queryInterviewDetail}?interviewId=${data}`
    )
    if (+res.code === 1024) {
      toCLogin(location.href)
    } else if (+res.code === 1) {
      return res.data || {}
    } else {
      Toast(res.msg)
      // throw res.msg
      return { empty: true }
    }
  } catch (e) {
    return null
  }
}
/*
 * 面试信息列表queryInterviewList
 */
export async function queryInterviewList(data: any) {
  try {
    const res: any = await httpWithCookie.get(`${api.queryInterviewList}`)
    if (+res.code === 1024) {
      toCLogin(location.href)
    } else if (+res.code === 1) {
      return res.data || []
    } else {
      Toast(res.msg)
    }
  } catch (e) {
    return null
  }
}
/*
 * 拒绝/接受面试
 */
export async function updateInterviewCfmStatus(data: any) {
  try {
    const { id, type } = data
    const res: any = await httpWithCookie.post(
      `${api.updateInterviewCfmStatus}?id=${id}&type=${type}`
    )
    if (+res.code === 1024) {
      toCLogin(location.href)
    } else if (+res.code === 1) {
      return res || {}
    } else {
      throw res.msg
    }
  } catch (e) {
    return null
  }
}
/*
 * 我的offer
 */
export async function getOfferList() {
  try {
    const res: any = await httpWithCookie.get(`${api.getOfferList}`)
    if (+res.code === 1024) {
      toCLogin(location.href)
    } else if (+res.code === 1) {
      return res.data || {}
    } else {
      throw res.msg
    }
  } catch (e) {
    return null
  }
}
/*
 * 拒绝/接受offer
 */
export async function updateOfferCfmStatus(data: any) {
  try {
    const { id, type } = data
    const res: any = await httpWithCookie.get(
      `${api.updateOfferCfmStatus}?id=${id}&type=${type}`
    )
    if (+res.code === 1024) {
      toCLogin(location.href)
    } else if (+res.code === 1) {
      return res
    } else {
      throw res.msg
    }
  } catch (e) {
    return null
  }
}
/*
 * 发送验证码
 */
export async function sendVerifyCode(data: any) {
  try {
    const res: any = await httpWithCookie.post(`${api.sendVerifyCode}`, data)
    if (+res.code === 1024) {
      toCLogin(location.href)
    } else if (+res.code === 1) {
      return res
    } else {
      Toast(res?.msg)
      return Promise.reject(res)
    }
  } catch (e) {
    return Promise.reject(e)
  }
}
/*
 * 登录
 */
export async function Login(data: any) {
  try {
    const res: any = await httpWithCookie.post(`${api.loginVCode}`, data)
    if (+res.code === 1024) {
      toCLogin(location.href)
    } else if (+res.code === 1) {
      return res
    } else {
      Toast(res.msg)
      throw res.msg
    }
  } catch (e) {
    return null
  }
}
/*
 * 简历解析
 */
export async function upload(data: any) {
  try {
    console.log(data, 333333)
    const res: any = await httpWithCookie({
      url: `${api.upload}?type=23&objectType=7`,
      data,
      method: 'post',
      headers: {
        'content-type':
          'multipart/form-data; boundary=----WebKitFormBoundarypys8B4PBkmAbi9IN'
      }
    })
    console.log(res, 66666)
    if (+res.code === 1024) {
      toCLogin(location.href)
    } else if (+res.code === 1) {
      return res
    } else {
      Toast(res.msg)
      throw res.msg
    }
  } catch (e) {
    return null
  }
}
/*
 * 保存简历
 */
export async function saveResumeApply(data: any) {
  try {
    const res: any = await httpWithCookie.post(`${api.saveResumeApply}`, data)
    if (+res.code === 1024) {
      toCLogin(location.href)
    } else if (+res.code === 1) {
      return res
    } else {
      Toast(res.msg)
      throw res.msg
    }
  } catch (e) {
    return null
  }
}
/*
 * 解析数据
 */
export async function parseResumeFromResumeData(data: any) {
  try {
    const res: any = await httpWithCookie.post(
      `${api.parseResumeFromResumeData}`,
      data
    )
    if (+res.code === 1024) {
      toCLogin(location.href)
    } else if (+res.code === 1) {
      return res
    } else {
      return res
    }
  } catch (e) {
    return null
  }
}
/*
 * 投递简历
 */
export async function saveApply(data: any) {
  try {
    const res: any = await httpWithCookie.post(`${api.saveApply}`, data)
    if (+res.code === 1024) {
      toCLogin(location.href)
    } else if (+res.code === 1) {
      return res
    } else {
      Toast(res.msg)
      throw res.msg
    }
  } catch (e) {
    return null
  }
}

// 查询当前所处步骤
export const fetchFinishPersonalInfo = (params: any) => {
  return requstData({
    url: `${api.finishPersonalInfo}`,
    params
  })
}

// 签到相关

// 面试列表
export const fetchInterviewList = () => {
  return requstData({
    url: `${baseMobileUrl}/applyRegister/queryTodayInterviewList.do`
  })
}
// 面试签到
export const saveInteviewSign = (data: any) => {
  return requstData({
    url: `${baseMobileUrl}/applyRegister/saveInteviewSign.do`,
    method: 'POST',
    data
  })
}

// 应聘登记信息查询
export const fetchApplyFormDetail = (params: any) => {
  return requstData({
    url: `${baseMobileUrl}/applyRegister/queryApplyRegister.do`,
    params
  })
}

// 应聘登记信息保存
export const saveApplyRegister = (data: any) => {
  return requstData({
    url: `${baseMobileUrl}/applyRegister/saveApplyRegister.do`,
    method: 'POST',
    data
  })
}

// 获取NC主档数据
export const fetchNCData = (params: any) => {
  return requstData({
    url: `${baseMobileUrl}/sysConf/getNcConf.do`,
    params
  })
}

// 查询是否有面试评价
export const fetchInterviewComment = (params: any) => {
  return requstData({
    url: `${baseMobileUrl}/interviewScore/validateSummaryToken.do`,
    params
  })
}

// 面试评价
export const saveInterviewComment = (params: any) => {
  return requstData({
    url: `${baseMobileUrl}/interviewScore/insertScore.do`,
    method: 'POST',
    data: params
  })
}

// 查询是否有应聘登记
export const fetchExistApplyRegister = (params: any) => {
  return requstData({
    url: `${baseMobileUrl}/applyRegister/queryExistApplyRegister.do`,
    params
  })
}

// 查询评价人信息
export const fetchInterviewerInfo = (params: any) => {
  return requstData({
    url: `${baseMobileUrl}/interviewScore/getPersonInfo.do`,
    params
  })
}

// 我的视频
export const fetchMyVideo = (params: any) => {
  return requstData({
    url: `${baseMobileUrl}/recruitEmploy/queryVideo.do`,
    params
  })
}

export const deleteVideo = (params: any) => {
  return requstData({
    url: `${baseMobileUrl}/recruitEmploy/deleteVideo.do`,
    params
  })
}

// 保存我的视频
export const saveMyVideo = (params: any) => {
  return requstData({
    url: `${baseMobileUrl}/recruitEmploy/saveVideo.do`,
    method: 'POST',
    data: params
  })
}

// 上传视频授权接口
export const getVideoAuthorization = (params: any) => {
  return requstData({
    url: `${baseMobileUrl}/recruitEmploy/getVideoToken.do`,
    params
  })
}

// 当前登录人信息接口
export const getLoginUserPhone = () => {
  return requstData({
    url: `${baseMobileUrl}/login/loginUserInfo.do`
  })
}

// 微信快速登录接口
export const wxQuickLoginApi = (data: any) => {
  return requstData({
    url: `${baseMobileUrl}/login/wxQuickLogin.do`,
    data,
    method: 'post'
  })
}

export const unBindWxApi = () => {
  return requstData({
    url: `${baseMobileUrl}/login/unbindWxLogout.do`
  })
}

// 获取滑动校验信息
export const fetchCaptchaCode = (params?: any) => {
  return requstData({
    url: `${baseMobileUrl}/verify/getCaptchaCode.do`,
    method: 'POST',
    data: params
  })
}

export const fetchAiResult = (params?: any) => {
  return requstData({
    url: `${apiPrefixes.ehr}/recruitEmploy/queryResumePostAnaly.do`,
    params
  })
}
